import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router';
import VueLocalStorage from 'vue-localstorage'
import VueHack from './libs/vuehack.plugin'

import Util from './libs/util';
import App from './App.vue';
import routes from './router'

import store from './store'
import Auth from './libs/auth'

Vue.use(VueRouter)
Vue.use(iView)
Vue.use(VueHack)
Vue.use(VueLocalStorage)

import 'iview/dist/styles/iview.css'; 

// 路由配置
const RouterConfig = {
    linkActiveClass: 'active',
    linkExactActiveClass:'current',
    routes: routes
}

// 创建路由实例
const router = new VueRouter(RouterConfig)

/**
 * 全局钩子
 */ 
function config_router() {
    router.beforeEach((to, from, next) => {
        if(!to.meta.public ) {
		    if (Auth.isLogin()) {
		    	iView.LoadingBar.start()
			    if(to.meta && to.meta.title){
					Util.title(to.meta.title)
				}
			    next()
		    } else {
		    	let path = '/login',
		    		query = {referer:to.path}
		    	if(to.query.token){
		    		path = '/tklogin'
		    		query.tk = to.query.token
		    		for(let o in to.query){
		    			if(o !== 'token'){
		    				query[o] = to.query[o]
		    			}
		    		}
		    		
		    	}
		    	next({path:path,query:query})
		    }
		}else{
			if(to.meta && to.meta.title){
				Util.title(to.meta.title)
			}
		    next()
		}
    })
    router.afterEach(() => {
    	if(Auth.isLogin()){
	        iView.LoadingBar.finish()
	        window.scrollTo(0, 0)
	    }
    })
}

/**
 * http全局配置
 */
function config_http(){
	Vue.http.options.root = '/vipapi'
	Vue.http.interceptors.push(function(request,next){
		if(request.method == 'GET'){
			store.commit('httpRequestStart',request.url)
		}else{
			store.commit('httpSavingStart',{url:request.url,method:request.method})
		}
		Vue.http.headers.common['x-client-time']   = Math.round((new Date()).getTime()/1000).toString()
	    next(function (response) {
	    	if(request.method == 'GET'){
	    		store.commit('httpRequestEnd',request.url)
	    	}else{
	    		store.commit('httpSavingEnd',{url:request.url,method:request.method})
	    	}
	    	if(response.body.authed){
	    		store.commit('updateLoginExpire')
	    	}
	    })
	})
}

const vtooltipConfig = {
    
}
  
function reg_directives(){
    
}

/**
 * 启动App
 */
function start() {
    new Vue({
        el: '#app',
        router: router,
        store: store,
        render: h => h(App)
    })
}

export default {
    config_router,
    config_http,
    reg_directives,
    start
}


// WEBPACK FOOTER //
// ./src/bootstrap.js